import { useNavigate } from 'react-router-dom';
import { useClerk } from '@clerk/clerk-react';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { signOut } = useClerk();

  const handleSignOut = async () => {
    await signOut();
    navigate('/sign-in');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
            <ShieldX className="h-10 w-10 text-destructive" />
          </div>
        </div>
        <h1 className="mb-2 text-3xl font-bold">Access Denied</h1>
        <p className="mb-6 text-muted-foreground">
          You don't have permission to access the admin dashboard.
          <br />
          Please contact an administrator if you believe this is an error.
        </p>
        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={() => navigate('/')}>
            Go to Home
          </Button>
          <Button variant="outline" onClick={handleSignOut}>
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
}
